package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.closing_reports_content.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CashbookTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.PaymentMethodTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.Cashbook
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.Coupon
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.PaymentMethod
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.jetbrains.compose.web.css.px


@Composable
fun CashBookAndCoupons(
    windowSizeMode: WindowSizeModeEnum,
    paymentMethod: List<PaymentMethod>?,
    cashBook: List<Cashbook>?,
    coupon: List<Coupon>?,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        MediumContentTitle(
            title = Strings.current().cashBookAndCoupons
        )


        if (windowSizeMode== WindowSizeModeEnum.PHONE)
        {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
            )
            {
                PaymentsMethod(
                    paymentMethod=paymentMethod
                )

                CashbookAndCoupons(
                    coupon=coupon,
                    cashBook=cashBook,
                    windowSizeMode = windowSizeMode,
                )
            }
        }else{
            Row(
                modifier = Modifier
                    .fillMaxWidth()
            )
            {
                PaymentsMethod(
                    paymentMethod=paymentMethod
                )

                CashbookAndCoupons(
                    coupon=coupon,
                    cashBook=cashBook,
                    windowSizeMode = windowSizeMode,
                )
            }
        }

    }


}

@Composable
private fun CashbookAndCoupons(
    windowSizeMode: WindowSizeModeEnum,
    coupon: List<Coupon>?,
    cashBook: List<Cashbook>?,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(
                left = if (windowSizeMode == WindowSizeModeEnum.PHONE) 0.px
                else Dimen.normalPadding,
                bottom = Dimen.mediumPadding,
                top = Dimen.mediumPadding
            )
    ) {
        val columns = CashbookTableHeadersEnum.entries.map { headerEnum ->
            TableColumn(
                header = headerEnum.title,
                key = headerEnum.key,
                isNumeric = headerEnum.isNumeric,
            )
        }

        val tableData = cashBook?.mapIndexed { index, model ->
            mapOf(
                CashbookTableHeadersEnum.INCOME_EXPENSE.key to (model.description ?: ""),
                CashbookTableHeadersEnum.AMOUNT.key to (
                        if (index < (coupon?.size ?: 0))
                            coupon?.get(index)?.name ?: ""
                        else ""
                )
            )
        }

        CustomTable(
            columns = columns,
            data = tableData,
            height = (Dimen.closingReportTable3Height),
            footerType = FooterType.NONE,
        )
    }
}


@Composable
private fun PaymentsMethod(
    paymentMethod: List<PaymentMethod>?,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = Dimen.mediumPadding)
    ) {
        val columns = PaymentMethodTableHeadersEnum.entries.map { headerEnum ->
            TableColumn(
                header = headerEnum.title,
                key = headerEnum.key,
                isNumeric = headerEnum.isNumeric,
            )
        }
        val tableData = paymentMethod?.map { model ->
            mapOf(
                PaymentMethodTableHeadersEnum.CREDIT.key to (model.name ?: ""),
                PaymentMethodTableHeadersEnum.NUMBER.key to formatToTwoDecimals(model.count),
                PaymentMethodTableHeadersEnum.AMOUNT.key to formatToTwoDecimals(model.amount)
            )
        }

        CustomTable(
            columns = columns,
            data = tableData,
            modifier = Modifier
                .fillMaxWidth()
                .height(Dimen.closingReportTable3Height),
            footerType = FooterType.NONE,
        )
    }
}
